import { getText } from "shared/lib";

import { Toggle } from "shared/components";

export type YesNoQuestions = string;

export interface YesNoQuestionListProps {
  answers: Array<boolean | null>;
  onChangeAnswers: (answers: Array<boolean | null>) => void;
  questions: Array<YesNoQuestions>;
  subtitle?: string | null;
  title?: string | null;
}

export function YesNoQuestionList({
  answers,
  onChangeAnswers,
  questions,
  subtitle,
  title,
}: YesNoQuestionListProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        {title && (
          <h2 className="text-headingxl text-textPrimary">{title}</h2>
        )}

        {subtitle && (
          <p className="text-textSubdued text-bodylg">{subtitle}</p>
        )}
      </div>

      <div className="text-bodymd text-textPrimary flex flex-col gap-6 overflow-y-auto">
        {questions.length > 0 && questions.map((question, index) => {
          return (
            <div className="flex flex-col gap-2" key={index}>
              <p>{question}</p>
              <div className="flex gap-2">
                <Toggle
                  onPressedChange={(pressed) => {
                    const newAnswers = [...answers];
                    newAnswers[index] = true;
                    onChangeAnswers(newAnswers);
                  }}
                  pressed={
                    answers[index] !== undefined && answers[index] === true
                  }
                  variant="rounded"
                >
                  {getText("Yes")}
                </Toggle>
                <Toggle
                  onPressedChange={(pressed) => {
                    const newAnswers = [...answers];
                    newAnswers[index] = false;
                    onChangeAnswers(newAnswers);
                  }}
                  pressed={
                    answers[index] !== undefined && answers[index] === false
                  }
                  variant="rounded"
                >
                  {getText("No")}
                </Toggle>
                <Toggle
                  onPressedChange={(pressed) => {
                    const newAnswers = [...answers];
                    newAnswers[index] = null;
                    onChangeAnswers(newAnswers);
                  }}
                  pressed={answers[index] === null}
                  variant="rounded"
                >
                  {getText("Unsure")}
                </Toggle>
              </div>
            </div>
          );
        })}

        {questions.length === 0 && (
          <p>{getText("There are no further questions, please click continue.")}</p>
        )}
      </div>
    </div>
  );
}
